import { Box } from "@mui/material";

import CommonSkeleton from "./CommonSkeleton";
import Text from "./text/Text";

function RecentSentSkeleton(props) {
  return (
    <Box className="loader-list">
      <Box className="mb-16">
        <CommonSkeleton width="110px" />
      </Box>
      <Box display="flex" alignItems="flex-start" gap={1}>
        <CommonSkeleton variant="circle" height="42px" width="42px" />
        <Box ml="14px">
          <Text className="grey-text" size={24} font="regular">
            <CommonSkeleton width="114px" />
          </Text>
          <Text className="default-text" size={16} font="semibold">
            <CommonSkeleton width="138px" />
          </Text>
          <Text className="default-text" size={16} font="semibold">
            <CommonSkeleton width="100px" />
          </Text>
        </Box>
      </Box>
    </Box>
  );
}

export default RecentSentSkeleton;
